export default [
  {
    name: 'groupDetail',
    path: '/group/detail',
    meta: { title: '拼团详情' },
    component: () => import('@/pages/groupActivity/groupDetail.vue'),
  },
  {
    name: 'trainGroupDetail',
    path: '/trainGroup/detail',
    meta: { title: '拼团详情' },
    component: () => import('@/pages/groupActivity/trainGroupDetail.vue'),
  },
  {
    name: 'groupRecord',
    path: '/group/record',
    meta: { title: '我的拼团' },
    component: () => import('@/pages/groupActivity/groupRecord.vue'),
  },
]
